module.exports = __webpack_public_path__ + "static/img/09.70d73f4d.png";